export const isInternetExplorer = () => {
  // @ts-ignore
  return !window.ActiveXObject && "ActiveXObject" in window;
};
